module.exports = __webpack_public_path__ + "static/media/FaVacBidUserGuide.c91eb776.pdf";